export var spot = {
    toggleCurrency: function (t) {
        var active = t.dataset.active;
        var isAUD = active === "aud";
        // Set the next active currency
        var nextCurrency = isAUD ? "usd" : "aud";
        // Hide current currency elements
        var currentFlag = document.querySelector("#flag_".concat(active));
        var currentSpot = document.querySelector("#spot_".concat(active));
        // Show next currency elements
        var nextFlag = document.querySelector("#flag_".concat(nextCurrency));
        var nextSpot = document.querySelector("#spot_".concat(nextCurrency));
        // Apply display changes if elements exist
        if (currentFlag)
            currentFlag.style.display = "none";
        if (currentSpot)
            currentSpot.style.display = "none";
        if (nextFlag)
            nextFlag.style.display = "inline-flex";
        if (nextSpot)
            nextSpot.style.display = "block";
        // Update the active state
        t.dataset.active = nextCurrency;
    },
};
